import React from 'react';

import { Wrapper, HeroImage, HeroImage2, Overlay } from './styled';

const Background = () => {
  return (
    <Wrapper>
      <HeroImage />
      <HeroImage2 />
      <Overlay />
    </Wrapper>
  );
};

export default Background;



// WEBPACK FOOTER //
// ./src/components/Hero/Background/Background.js